import { exec } from "jadelet"
export default exec(["tools",{"class":[{"bind":"toolsClass"}],"click":{"bind":"toggleToolsOpen"}},[{"bind":"instrumentTools"},{"bind":"additionalTools"}]])